export interface IDonorConnectCompletionsReport {
    userId: number,
    username: string,
    firstContactsAssigned: number,
    firstContactAttempts: number,
    firstContactsMade: number,
    surveysCompletedForWorkup: number,
    surveysCompletedForPreOp: number,
    surveysCompletedAtSurgery: number,
    surveysCompletedPostSurgery: number,
    donationsMade: number
}